/**
 * Regras de idade, do lado da tela.
 *
 * O servidor decide (Services/AgeRules.js); aqui a tela apenas antecipa, para
 * pedir os dados do responsável antes de o cadastro ser recusado.
 *
 *   Termos 2.1 - anfitrião precisa ter 18 anos
 *   Termos 2.2 - conviva a partir de 13, e de 13 a 18 com autorização dos pais
 */
export const IDADE_MINIMA_CONVIVA = 13;
export const IDADE_MINIMA_ANFITRIAO = 18;

// Nascimento chega como 'aaaa-mm-dd' do DateInput: data de calendário, sem
// fuso. Comparar pedaço a pedaço evita que o Date desloque um dia.
export const calcularIdade = (nascimento, hoje = new Date()) => {
    if (!nascimento) return null;

    const [ano, mes, dia] = String(nascimento).slice(0, 10).split('-').map(Number);
    if (!ano || !mes || !dia) return null;

    let idade = hoje.getFullYear() - ano;
    const aniversarioPassou =
        hoje.getMonth() + 1 > mes || (hoje.getMonth() + 1 === mes && hoje.getDate() >= dia);

    if (!aniversarioPassou) idade -= 1;
    return idade;
};

export const precisaDeResponsavel = nascimento => {
    const idade = calcularIdade(nascimento);
    return idade !== null && idade >= IDADE_MINIMA_CONVIVA && idade < IDADE_MINIMA_ANFITRIAO;
};
